/* Assets/ilf-texture-animated-banner.js */

class IlfTextureReveal {
  constructor(container) {
    this.container = container;
    // Get the unique ID from the HTML to target specific SVG clips
    this.sectionId = this.container.getAttribute('data-section-id'); 

    this.wrapper = this.container.querySelector('.ilf-reveal-wrapper');
    
    // Config: Geometry constants (0-1 range)
    this.config = {
      width: 0.38,   // 38% center width
      skew: -0.12,   // Skew factor
      offset: 0.06,  // Center offset
      duration: 0.8
    };

    this.coords = { a: 0, b: 0, s: 0 };
    this.activeTile = null;
    this.init();
  }

  init() {
    // Calculate default geometry
    const center = 0.5 + this.config.offset;
    this.coords.a = center - (this.config.width / 2);
    this.coords.b = center + (this.config.width / 2);
    this.coords.s = this.config.skew;
    this.render();
    this.bindEvents();
  }

  // Updates the invisible SVG polygons
  render() {
    const { a, b, s } = this.coords;
    // Map coordinates to SVG polygon points (0 to 1)
    const L = `0,0 ${a},0 ${a + s},1 0,1`;
    const C = `${a},0 ${b},0 ${b + s},1 ${a + s},1`;
    const R = `${b},0 1,0 1,1 ${b + s},1`;

    // Target the specific polygons for THIS section
    const polyL = this.container.querySelector('.ilf-poly-l');
    const polyC = this.container.querySelector('.ilf-poly-c');
    const polyR = this.container.querySelector('.ilf-poly-r');

    if(polyL) polyL.setAttribute('points', L);
    if(polyC) polyC.setAttribute('points', C);
    if(polyR) polyR.setAttribute('points', R);
  }

  animateTo(mode) {
    if (this.activeTile === mode) return;
    this.activeTile = mode;

    // Safety check for GSAP
    if (typeof gsap === 'undefined') return;

    const tl = gsap.timeline({
      onUpdate: () => this.render(),
      defaults: { duration: this.config.duration, ease: "power4.out" }
    });

    const allLabels = this.container.querySelectorAll(".ilf-label");
    const allButtons = this.container.querySelectorAll(".ilf-control-btn");
    
    // Get wrappers for z-index manipulation
    const wrappers = {
       l: this.container.querySelector('.ilf-wrapper-l'),
       c: this.container.querySelector('.ilf-wrapper-c'),
       r: this.container.querySelector('.ilf-wrapper-r')
    };

    // 1. Hide Text
    tl.to(allLabels, { opacity: 0, y: 15, duration: 0.2 }, 0);

    if (mode === 'COLLAPSE') {
      // --- COLLAPSE ---
      const center = 0.5 + this.config.offset;
      tl.to(this.coords, {
        a: center - (this.config.width / 2),
        b: center + (this.config.width / 2),
        s: this.config.skew
      }, 0);

      tl.to(allButtons, { scale: 1 }, 0);
      
      // Reset z-indexes after animation starts
      Object.values(wrappers).forEach(el => { if(el) el.style.zIndex = 1; });

    } else {
      // --- OPEN ---
      const suffix = mode.toLowerCase();
      const targetWrapper = wrappers[suffix];
      const targetBtn = this.container.querySelector(`.ilf-btn--${suffix}`);
      // const targetLabel = this.container.querySelector(`.ilf-label--${suffix}`);

      // Bring active image to front immediately
      if(targetWrapper) targetWrapper.style.zIndex = 10;

      // Animation Targets (Overshoot to cover full width)
      const over = 0.25;
      const targets = {
        L: { a: 1 + over, b: 1 + over, s: 0 },
        C: { a: -over, b: 1 + over, s: 0 },
        R: { a: -over, b: -over, s: 0 }
      }[mode];

      tl.to(this.coords, targets, 0);

      // Buttons
      tl.to(allButtons, { scale: 1 }, 0);
      if(targetBtn) tl.to(targetBtn, { scale: 1.8 }, 0);

      // Show Label
      // if(targetLabel) tl.to(targetLabel, { opacity: 1, y: 0, delay: 0.15 }, 0);
    }
  }

  bindEvents() {
    const map = { L: 'l', C: 'c', R: 'r' };

    Object.keys(map).forEach(mode => {
      const suffix = map[mode];
      const wrapperEl = this.container.querySelector(`.ilf-wrapper-${suffix}`);
      const btnEl = this.container.querySelector(`.ilf-btn--${suffix}`);

      if (!wrapperEl || !btnEl) return;

      // BUTTON INTERACTIONS
      // Touch: Hold to View (Blocks scrolling on the button to allow holding)
      const startHandler = (e) => {
         // preventDefault stops the browser from firing mouse events after touch, preventing double-trigger
         if(e.cancelable) e.preventDefault();
         // If this button is already active, collapse instead
         if (this.activeTile === mode) {
           this.animateTo('COLLAPSE');
         } else {
           this.animateTo(mode);
         }
      };
      const endHandler = (e) => {
         if(e.cancelable) e.preventDefault();
         this.animateTo('COLLAPSE');
      };

      btnEl.addEventListener('touchstart', startHandler, { passive: false });
      // btnEl.addEventListener('touchend', endHandler, { passive: false });
      
      // Mouse: Hover to View
      btnEl.addEventListener('mouseenter', () => this.animateTo(mode));
      // We don't need mouseleave on the button specifically because the wrapper handles the collapse logic


      // 2. IMAGE WRAPPER INTERACTIONS
      // Touch: Tap to view (Passive allows scrolling if they drag)
      wrapperEl.addEventListener('touchstart', () => this.animateTo(mode), { passive: true });
      
      // Mouse: Hover
      wrapperEl.addEventListener('mouseenter', () => this.animateTo(mode));
    });

    // GLOBAL COLLAPSE TRIGGERS
    // Mouse: Collapse when cursor leaves the main container
    this.wrapper.addEventListener('mouseleave', () => this.animateTo('COLLAPSE'));

    // Touch: Collapse when tapping anywhere OUTSIDE the container
    document.addEventListener('touchstart', (e) => {
      if (!this.wrapper.contains(e.target)) {
        this.animateTo('COLLAPSE');
      }
    }, { passive: true });
  }
}

// --- Initialization Helper ---
function initTextureReveal(container) {
  if (container.dataset.ilfInitialized) return; 
  new IlfTextureReveal(container);
  container.dataset.ilfInitialized = true;
}

// 1. Init on Page Load
document.addEventListener("DOMContentLoaded", () => {
  const sections = document.querySelectorAll('[data-section-type="ilf-texture-animated-banner"]');
  sections.forEach(section => initTextureReveal(section));
});

// 2. Init on Shopify Theme Editor Load
document.addEventListener('shopify:section:load', (e) => {
  if (e.target.dataset.sectionType === 'ilf-texture-animated-banner') {
    initTextureReveal(e.target.querySelector('[data-section-type="ilf-texture-animated-banner"]'));
  }
});